import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { ILeasedEquipStatus } from "../Types";
import { editStateStatus } from "../atoms/atoms";

export default function LeasedEquipmentStatusDetails(props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: ILeasedEquipStatus | undefined;
}) {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateStatus);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [inputData, setInputData] = useState(
    data?.leasedEquipmentStatusName || ""
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.status);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="leasedEquipmentStatusName"
                label="Status Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);
                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value === data?.leasedEquipmentStatusName &&
                      checkBoxChanges === data?.status)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.leasedEquipmentStatusName &&
                  formMethods.formState.errors.leasedEquipmentStatusName
                    .message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("leasedEquipmentStatusName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="status"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);
                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.status &&
                        inputData === data?.leasedEquipmentStatusName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
